<template>
  <div>
    <div class="team-calendar-activator text-dark no-print"
         :content="'<p class=' + 'tooltip-shortcut' + '>' + $t('vue2.common.press') + '<span>S</span></p>'"
         v-tippy="{arrow: true,placement : 'right'}"
         :class="{'team-calendar-activator--is-active': showTeamCalendar}"
         @click="toggleShowTeamCalendar">
      <button class=" box-shadow submit-button button--rounded">
        <span v-if="!showTeamCalendar" class="icon-users"></span>
        <span v-else class="icon-cross2"></span>
      </button>
      <p v-html="i18n[locale]['button_text']"></p>
    </div>
    <transition name="fadeIn">
      <div class="background-overlay" v-if="showTeamCalendar"></div>
    </transition>
    <transition name="slideUp">
      <div class="overlay-calendars text-dark" v-show="showTeamCalendar">
        <div class="team-calendar" :class="{'team-calendar--week-view': calView === 'resourceTimeGridFiveDay'}">
          <div class="team-calendar__header flex space-between no-print">
            <h1>{{ i18n[locale]['team_calendar'] }}</h1>
            <div @click="closeTeamCalendar"
                 class="icon__bg-circle team-calendar__close-cross pointer font-large no-print">
              <span class="icon-cross2"></span>
            </div>
          </div>
          <div class="team-calendar__body">
            <calHeader
              :date="date"
              :calview="calView"
              :itemsSelected="selectedRess"
              :selectedScrollOption="selectedScrollOption"
              @dateChange="setDate"
              @setView="setCalView"
              @updateEvents="updateEvents"
              @usersUpdated="setSelectedRess"
              @changedSortOption="setSortOption"
              @setSelectedScrollOption="setSelectedScrollOption">
            </calHeader>
            <div class="team-calendar__calendars"
                 :class="{'team-calendar__calendars--loading-events': isLoadingEvents && isCalendarView}"
                 id="printTeamCalendar">
              <spinner v-if="isLoading"></spinner>
              <div class="team-calendar__loader-container" v-if="isLoadingEvents && isCalendarView">
                <spinner bg-color="#fff"></spinner>
                <h4 class="italic">{{ i18n[locale]['loading_events'] }}</h4>
              </div>
              <Collisions
                v-if="calView === 'doubleBookings'"
                :date="date"
                :show="showTeamCalendar"
                @prevDay="setPrevDay"
                @nextDay="setNextDay"
              ></Collisions>
              <dScheduler v-if="isSchedulerView && !isLoading"
                          :calendars="selectedRess"
                          :events="events"
                          :title="schedulerDate"
                          :isLoading="isLoadingEvents">
              </dScheduler>
              <dScheduler
                v-if="isShowSchedulerShortcut"
                :title="schedulerDate"
                :calendars="theSchedulerCalendars"
                :isLoading="isLoadingEvents"
                :events="theSchedulerEvents"
                :sortBy="theSortOptionForAllSchedules">
              </dScheduler>
              <transition name="zoomIn">
                <DCalendarShowEvent
                  v-if="activeEvent"
                  :event="activeEvent"
                  :calendar="activeCalendar"
                  :initCalendarId="activeEventCalendarId"
                  @updated="updateEvents"
                  @close="setActiveEvent(null)">
                </DCalendarShowEvent>
              </transition>
              <div class="calendar_container" :class="{'calendar_container--side-scroll': selectedScrollOption === 'horizontal'}" ref="calContainerRef"
                   v-if="selectedRess.length > 0 && isCalendarView && !isLoading">
                <div class="d-cals">
                  <div class="d-cals__calendar" v-for="(calendar, idx) in selectedRess" :key="calendar.id">
                    <DCalendar
                      :initNumberOfDays="userCustomNumberOfDays"
                      :isMultiCalendar="true"
                      :isShowStudents="true"
                      :date="date"
                      :isEventsClickable="isUserCanEditCalendar"
                      :events="getCalendarEvents(calendar.id)"
                      :startTime="startTime"
                      :endTime="endTime"
                      :isShowWeek="isShowWeek"
                      :isShowWeekends="isShowWeekends"
                      :calendarId="calendar.id"
                      :calendarName="calendar.name"
                      :showSidebar="idx % 5 === 0"
                      :isShowAsList="isListView"
                      @onEventClick="setActiveEvent($event, calendar)">
                    </DCalendar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import calHeader from './TeamCalendarHeader'
import dScheduler from '../DScheduler/DScheduler'
import spinner from '../common/Loader'
import DCalendar from '../DCalendar/DCalendar'
import docendo from '../../docendo'
import moment from 'moment'
import Collisions from '../Collisions/Collisions'
import DCalendarShowEvent from '../DCalendar/DCalendarShowEvent'

export default {
  components: {DCalendarShowEvent, Collisions, DCalendar, calHeader, dScheduler, spinner},
  data () {
    return {
      i18n: {
        da: {
          button_text: 'Skema-<br>overblik',
          team_calendar: 'Skemaoverblik',
          loading_events: 'Henter lektioner..'
        },
        en: {
          button_text: 'Schedule<br>overview',
          team_calendar: 'Schedule overview',
          loading_events: 'Loading events..'
        },
        nb: {
          button_text: 'Timeplan-<br>overblikk',
          team_calendar: 'Timeplanoverblikk',
          loading_events: 'Loading events..'
        }
      },
      showTeamCalendar: false,
      calView: 'resourceTimeGridFiveDay',
      date: moment().format('YYYY-MM-DD 00:00'),
      maxRessLength: 4,
      selectedRess: [],
      events: [],
      prevCounter: 0,
      nextCounter: 0,
      todayCounter: 0,
      theSchedulerCalendars: [],
      theSchedulerEvents: [],
      rooms: [],
      isLoading: false,
      isLoadingEvents: false,
      timeout: null,
      _keyListener: null,
      theSortOptionForAllSchedules: null,
      activeEvent: null,
      activeCalendar: null,
      activeEventCalendarId: null,
      selectedScrollOption: ''
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    schoolId () {
      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id
    },
    locale () {
      return this.user && this.user.locale ? this.user.locale : 'en'
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    allCalendars () {
      return this.$store.state.calendars
    },
    userCalendars () {
      return this.$store.getters.userCalendars
    },
    isListView () {
      return this.calView === 'listView'
    },
    isSchedulerView () {
      return this.calView === 'schedulerView'
    },
    isShowSchedulerShortcut () {
      return this.calView === 'scheduler' || this.calView === 'scheduler__all_cals' || this.calView === 'scheduler__all_users'
    },
    isCalendarView () {
      return this.calView === 'resourceTimeGridFiveDay' || this.calView === 'resourceTimeGridDay' || this.calView === 'listView'
    },
    isShowWeek () {
      return this.calView !== 'resourceTimeGridDay'
    },
    startDate () {
      let startDate = moment(this.date).format('YYYY-MM-DD 00:00')
      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView') {
        startDate = moment(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00')
      }
      return startDate
    },
    endDate () {
      let endDate = moment(this.date).format('YYYY-MM-DD 23:59')
      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView') {
        if (this.isShowWeekends) {
          endDate = moment(this.date).isoWeekday(7).format('YYYY-MM-DD 23:59')
        } else {
          endDate = moment(this.date).isoWeekday(5).format('YYYY-MM-DD 23:59')
        }
        if (this.userCustomNumberOfDays) {
          endDate = moment(this.date).isoWeekday(this.userCustomNumberOfDays).format('YYYY-MM-DD 23:59')
        }
      }
      return endDate
    },
    dateRangeFormatted () {
      // alternative is just to show the month?
      let isInSameMonth = moment(this.startDate).format('MM') === moment(this.endDate).format('MM')
      let start = isInSameMonth ? moment(this.startDate).format('DD[.]') : moment(this.startDate).format('DD[.] MMM')
      if (this.locale !== 'en') {
        if (this.calView !== 'resourceTimeGridDay') {
          return start + ' - ' + moment(this.endDate).format('DD[.] MMM[,] YYYY')
        } else {
          return moment(this.endDate).format('DD[.] MMM[,] YYYY')
        }
      } else {
        start = moment(this.startDate).format('MMM DD')
        let end = isInSameMonth ? moment(this.endDate).format('DD[,] YYYY') : moment(this.endDate).format('MMM DD[,] YYYY')
        if (this.calView !== 'resourceTimeGridDay') {
          return start + ' - ' + end
        } else {
          return moment(this.endDate).format('MMM DD[,] YYYY')
        }
      }
    },
    startTime () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
        const end = moment(this.userSettings.teamCalendarSettingTimes.end)
        const start = moment(this.userSettings.teamCalendarSettingTimes.start)
        if (moment(start).isBefore(end)) {
          return moment(this.userSettings.teamCalendarSettingTimes.start).format('HH:mm:00')
        } else {
          this.$store.dispatch('deleteUserSetting', 'teamCalendarSettingTimes')
        }
      } else {
        return '07:00:00'
      }
    },
    endTime () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
        return moment(this.userSettings.teamCalendarSettingTimes.end).format('HH:mm:00')
      } else {
        return '16:00:00'
      }
    },
    isShowWeekends () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
        return this.userSettings.teamCalendarSettingTimes.isShowWeekends
      } else {
        return false
      }
    },
    userCustomNumberOfDays () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.numberOfDays) {
        return this.userSettings.teamCalendarSettingTimes.numberOfDays
      } else {
        return null
      }
    },
    schedulerDate () {
      return moment(this.date).format('dddd') + ', ' + moment(this.date).format('ll')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    roomsGetter () {
      return this.$store.getters.roomCalendars
    },
    eventsInHash () {
      let eventsHash = {}
      this.events.forEach(event => {
        if (event.event_type === 'presence') {
          const calId = event.calendar_id
          if (!eventsHash[calId]) {
            eventsHash[calId] = [event]
          } else {
            eventsHash[calId].push(event)
          }
        } else {
          event.calendars.forEach(calendar => {
            const calId = calendar.calendar_id
            if (!eventsHash[calId]) {
              eventsHash[calId] = [event]
            } else {
              eventsHash[calId].push(event)
            }
          })
        }
      })
      return eventsHash
    },
    isUserCanEditCalendar () {
      return this.$store.getters.isUserCanEditCalendar
    }
  },
  methods: {
    readInitialScrollOption () {
      const key = 'd_team_calendar_scroll_option'
      const val = this.$helpers.getLocalStorage(key)
      if (val) {
        this.selectedScrollOption = val
      }
    },
    setSelectedScrollOption (val) {
      this.selectedScrollOption = val
      const key = 'd_team_calendar_scroll_option'
      if (val === '') {
        this.$helpers.removeLocalStorage(key)
      } else {
        this.$helpers.setLocalStorage(key, val)
      }
    },
    setSortOption (sortBy) {
      this.theSortOptionForAllSchedules = sortBy
    },
    getCalendarEvents (calendarId) {
      return this.eventsInHash[calendarId] ? this.eventsInHash[calendarId] : []
    },
    setNextDay () {
      const newDate = moment(this.date).add(1, 'days')
      this.setDate(newDate)
    },
    setPrevDay () {
      const newDate = moment(this.date).subtract(1, 'days')
      this.setDate(newDate)
    },
    setDate (mom) {
      this.date = mom
      if (this.calView === 'doubleBookings') {
        return
      }
      setTimeout(_ => {
        this.getEvents()
      }, 0)
    },
    setCalView (val) {
      if (this.calView === val) {
        return
      }
      if (val === 'scheduler') {
        this.theSchedulerCalendars = this.roomsGetter
      }
      if (val === 'scheduler__all_cals') {
        this.theSchedulerCalendars = this.$helpers.sortArrOnName(this.allCalendars)
      }
      if (val === 'scheduler__all_users') {
        this.theSchedulerCalendars = this.userCalendars
      }
      this.calView = val
      this.getEvents()
    },
    setCalDate (calDate) {
      if (moment(this.date).format('YYYY-MM-DD') !== moment(calDate).format('YYYY-MM-DD')) {
        this.date = calDate
      }
    },
    setToday () {
      this.todayCounter++
      this.date = moment()
    },
    setSelectedRess (calendars) {
      this.selectedRess = []
      calendars.forEach(calendar => {
        this.selectedRess.push(calendar)
      })
    },
    updateEvents ($event) {
      setTimeout(_ => {
        this.getEvents()
      }, 0)
    },
    setView () {
      this.getEvents()
    },
    getEvents () {
      if (this.calView === 'doubleBookings') {
        return
      }
      if (this.isShowSchedulerShortcut) {
        const calendarIds = this.theSchedulerCalendars.map(cal => cal.id)
        this.isLoadingEvents = true
        this.theSchedulerEvents = []
        docendo.eventsFromCalendars(calendarIds, this.startDate, this.endDate, null, data => {
          const events = data.length > 0 ? JSON.parse(data) : []
          this.theSchedulerEvents = events
          this.isLoadingEvents = false
        })
        return
      }
      if (this.selectedRess.length === 0) {
        return
      }
      const calendarIds = this.selectedRess.map(user => user.id)
      this.isLoadingEvents = true
      this.events = []
      docendo.eventsFromCalendars(calendarIds, this.startDate, this.endDate, null, data => {
        const events = data.length > 0 ? JSON.parse(data) : []
        this.events = events
        this.isLoadingEvents = false
      })
    },
    setShowTeamCalendar () {
      this.showTeamCalendar = true
      if (this.selectedRess.length > 0) {
        this.getEvents()
      }
      const body = document.querySelector('body')
      if (!body.classList.contains('no-scroll')) {
        body.classList.add('no-scroll')
      }
      const onEscape = (e) => {
        if (this.showTeamCalendar && e.keyCode === 27) {
          this.closeTeamCalendar()
        }
      }
      document.addEventListener('keydown', onEscape)
      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', onEscape)
      })
    },
    closeTeamCalendar () {
      this.showTeamCalendar = false
      const body = document.querySelector('body')
      body.classList.remove('no-scroll')
    },
    toggleShowTeamCalendar () {
      if (this.showTeamCalendar) {
        this.closeTeamCalendar()
      } else {
        this.setShowTeamCalendar()
      }
    },
    setActiveEvent (event, calendar) {
      if (!this.isUserCanEditCalendar) {
        return
      }
      if (!event) {
        this.activeEvent = null
        this.activeCalendar = null
        this.activeEventCalendarId = null
      } else {
        this.activeEvent = event.obj
        this.activeCalendar = calendar
        this.activeEventCalendarId = calendar.id
      }
    }
  },
  beforeMount () {
    window.addEventListener('vue_open_teamcalendar', e => {
      this.setShowTeamCalendar()
    })
    this.readInitialScrollOption()
    this.calView = this.userSettings['teamcalendar_view__tab_1']
    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option']
  },
  mounted () {
    this._keyListener = function (e) {
      //
      if (e.key === 's') {
        if ((e.target.tagName.toUpperCase() === 'BODY')) {
          this.toggleShowTeamCalendar()
        }
      }
    }
    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.slideUp-enter-active {
  transition: transform .3s;
}

.slideUp-enter, .slideUp-leave-to {
  transform: translateY(100%);
}

.overlay-calendars {
  position: fixed;
  transition: transform .4s;
  bottom: 0;
  left: 0;
  right: 0;
  height: 97vh;
  background-color: #edf0f5;
  overflow-y: hidden;
  z-index: 999999991;
  box-shadow: 0px 10px 40px -10px rgba(0, 64, 128, 0.2);
}

.overlay-calendars.teamCalIsOpen {
  transform: translateY(0);
}

.team-calendar__header {
  padding: 0px 60px;
  border-bottom: 1px solid #dadce0;
  height: 55px;
}

.team-calendar__body {
  height: calc(97vh - 55px);
  overflow-y: auto;
  padding: 1rem 2rem;
}

.team-calendar__close-cross {
  font-size: 20px !important;
  margin-left: 4rem;
  margin-top: 14px;
}

.team-calendar .user-tags {
  display: flex;
}

.team-calendar .user-tag {
  padding: 4px 6px;
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}

.team-calendar .user-tag__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}

.team-calendar .fc-button-group {
  margin-right: 5px;
}

#monthname {
  display: flex;
  font-size: 1.4rem;
  align-items: center;
  padding-left: 20px;
}

.public-app .fc-unthemed .fc-today {
  background: var(--active-blue);
}

.public-app .fc-v-event {
  cursor: pointer;
  min-height: 10px;
}

.public-app .fc-header-toolbar {
  display: none;
}

.public-app .fc-time-grid .fc-slats td {
  height: 2em;
}

.team-calendar-activator {
  position: fixed;
  left: 0;
  bottom: 25px;
  z-index: 1000;
  border-radius: 50%;
  height: 40px;
  width: 65px;
  text-align: center;
  cursor: pointer;
}

.team-calendar-activator > p {
  color: #ffffff;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  margin-top: 4px;
}

.background-overlay {
  position: fixed;
  left: 0px;
  bottom: 0px;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
}

.fadeIn-enter-active, .fadeIn-leave-active {
  transition: opacity .5s;
}

.fadeIn-enter, .fadeIn-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.flex-1 {
  flex: 1;
}

.justify-end {
  justify-content: flex-end;
}

.bttn--red {
  background-color: #fa565a !important;
  color: white !important;
}

.print-only {
  display: none;
}

.calendar_container {
  padding: 0 1rem;
  background: #ffffff;
}

.calendar_container.calendar_container--side-scroll {
  overflow-x: auto;
  overscroll-behavior: contain;
}

.d-cals {
  display: flex;
  flex-wrap: wrap;
}

.calendar_container.calendar_container--side-scroll .d-cals {
  flex-wrap: initial;
}

.d-cals__calendar {
  flex: 1;
  position: relative;
  height: 650px;
  max-width: 330px;
  min-width: 300px;
}

.team-calendar.team-calendar--week-view .d-cals__calendar {
  min-width: 25%;
  max-width: 100%;
}

@media print {
  .d-cals__calendar {
    max-width: initial;
    min-width: 20%;
    flex: 1 0 21%;
  }
  .print-only {
    display: block;
  }

  .d-cals {
    page-break-before: always;
  }

  .d-cals__calendar {
    page-break-before: always;
  }
}

.team-calendar__calendars {
  position: relative;
  height: 100%;
  background: #ffffff;
}

.team-calendar__calendars--loading-events:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(255 255 255 / 40%);
  z-index: 12;
}

.team-calendar__loader-container {
  position: absolute;
  top: 5.5rem;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 13;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.team-calendar__loader-container h4 {
  margin-top: -2rem;
}

</style>



// WEBPACK FOOTER //
// TeamCalendar.vue?1461d18f